import classnames from 'clsx';

import { DisplaySummaryMessage } from './display-summary-message';
import { OrderSummary } from '../../../edit-and-read-only-order-summary/order-summary';
import sectionStyle from '../orders-sidebar-section.module.less';
import style from './summary-section-content.module.less';

/**
 * @param {object} props
 * @param {object} [props.amountSummary]
 * @param {object[]} [props.discounts]
 * @param {string[]} [props.fulfillmentPlanIds]
 * @param {string} [props.holdUntilDateTime]
 * @param {string} [props.orderDateTime]
 * @param {string} [props.orderGridStatus]
 * @param {string} [props.paidDateTime]
 * @param {object[]} [props.salesOrders]
 * @param {string} [props.shipByDateTime]
 * @returns {JSX.Element}
 */
export const SummarySectionContent = ({
  amountSummary,
  discounts,
  fulfillmentPlanIds,
  holdUntilDateTime,
  orderDateTime,
  orderGridStatus,
  paidDateTime,
  salesOrders,
  shipByDateTime,
}) => {
  return (
    <div className={classnames(style['summary-section'], sectionStyle['order-sidebar-section-default-padding'])}>
      <DisplaySummaryMessage
        className={style['display-summary-message']}
        fulfillmentPlanIds={fulfillmentPlanIds}
        salesOrders={salesOrders}
      />
      {salesOrders.length === 1 && (
        <OrderSummary
          amountSummary={amountSummary}
          classes={style['order-summary']}
          discounts={discounts}
          holdUntilDateTime={holdUntilDateTime}
          isInDrawer
          orderDateTime={orderDateTime}
          orderGridStatus={orderGridStatus}
          paidDateTime={paidDateTime}
          salesOrderId={salesOrders[0].salesOrderId}
          shipByDateTime={shipByDateTime}
        />
      )}
    </div>
  );
};
